/* global $ */

if ($.fn.chosen) {
  $('.filter-form select').chosen({
    disable_search: 'true',
  });
}

$('.searchandfilter').append('<button type="submit"></button>');
$('.searchandfilter [type="submit"]').hide();

$('.sf-field-taxonomy-type select, .sf-field-category select').on(
  'change',
  () => {
    $('.searchandfilter [type="submit"]').click();
  },
);

const $filterLabel = $('.filter-form label');

setTimeout(() => {
  if (
    $(
      '.sf-field-taxonomy-type .chosen-container, .sf-field-category .chosen-container',
    ).length
  ) {
    $filterLabel.addClass('chosen-active');
  } else {
    $filterLabel.addClass('no-chosen');
  }
}, 1000);
